import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

type LoginView = 'otp' | 'email' | 'signup' | 'selectEmail';

interface LoginUiState {
  isLoginOpen: boolean;
  initialView: LoginView;
  /** Design ID to add to wishlist after the user completes login via popup. */
  pendingWishlistDesignId: number | null;
}

const initialState: LoginUiState = {
  isLoginOpen: false,
  initialView: 'otp',
  pendingWishlistDesignId: null,
};

const loginUiSlice = createSlice({
  name: 'loginUi',
  initialState,
  reducers: {
    openLoginPopup(state, action: PayloadAction<LoginView | undefined>) {
      state.isLoginOpen = true;
      state.initialView = action.payload ?? 'otp';
    },
    closeLoginPopup(state) {
      state.isLoginOpen = false;
      state.pendingWishlistDesignId = null;
    },
    setPendingWishlistDesignId(state, action: PayloadAction<number>) {
      state.pendingWishlistDesignId = action.payload;
    },
    clearPendingWishlistDesignId(state) {
      state.pendingWishlistDesignId = null;
    },
  },
});

export const { openLoginPopup, closeLoginPopup, setPendingWishlistDesignId, clearPendingWishlistDesignId } =
  loginUiSlice.actions;
export const loginUiReducer = loginUiSlice.reducer;
